/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CompositeSearchEnhancedFilterConditionType } from './CompositeSearchEnhancedFilterConditionType';

export type CompositeSearchEnhancedFilterUdfNumber = {
    filterType: CompositeSearchEnhancedFilterUdfNumber.filterType;
    conditionType: CompositeSearchEnhancedFilterConditionType;
    value: Array<number>;
};

export namespace CompositeSearchEnhancedFilterUdfNumber {

    export enum filterType {
        UDF_NUMBER1 = 'udfNumber1',
        UDF_NUMBER2 = 'udfNumber2',
        UDF_NUMBER3 = 'udfNumber3',
        UDF_NUMBER4 = 'udfNumber4',
        UDF_NUMBER5 = 'udfNumber5',
        UDF_NUMBER6 = 'udfNumber6',
        UDF_NUMBER7 = 'udfNumber7',
        UDF_NUMBER8 = 'udfNumber8',
        UDF_NUMBER9 = 'udfNumber9',
        UDF_NUMBER10 = 'udfNumber10',
    }


}

